import { render, staticRenderFns } from "./examCard.vue?vue&type=template&id=7d9618c4&scoped=true"
import script from "./examCard.vue?vue&type=script&lang=js"
export * from "./examCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9618c4",
  null
  
)

export default component.exports